/* Feedback only: Shopify still owns submission, CAPTCHA and server confirmation.
 * Do not AJAX this form, disable its controls, call form.submit(), or prevent the
 * native event: Shopify may defer and resume it after its security challenge. */
(function () {
  'use strict';
  if (window.avalyNewsletterStatusReady) return;
  window.avalyNewsletterStatusReady = true;

  function showPending(form) {
    var status = form.querySelector('[data-avaly-newsletter-progress]');
    if (!status) return;
    clearTimeout(form.avalyNewsletterTimer);
    status.hidden = false;
    status.textContent = 'Continue with the security check if prompted. Your signup is not confirmed yet.';
    form.avalyNewsletterTimer = setTimeout(function () {
      status.textContent = 'This page has not confirmed your signup. Complete any security check shown. If nothing happens, reload the page or email hello@avaly.au for help.';
    }, 12000);
  }

  // Capture observes an attempt before a Shopify CAPTCHA listener can pause it.
  // Neither listener cancels, resubmits or claims that the provider accepted it.
  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest && event.target.closest('button[type="submit"]');
    var form = control && control.closest('form[data-avaly-newsletter]');
    if (form && form.checkValidity()) showPending(form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[data-avaly-newsletter]') && form.checkValidity()) showPending(form);
  }, true);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('form[data-avaly-newsletter]').forEach(function (form) {
      clearTimeout(form.avalyNewsletterTimer);
      var status = form.querySelector('[data-avaly-newsletter-progress]');
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
    });
  });
})();
